import { CategoryContextType, UICategory, UIService } from '../../contexts/CategoryContext';
import { StateUpdater, useCallback, useMemo } from 'preact/hooks';

export type ServiceProps = {
  categories: UICategory[];
  onServiceToggle: (checked: boolean, serviceId: string) => void;
  services: UIService[];
  setCategories: StateUpdater<UICategory[]>;
};

const MapServices: (props: CategoryContextType) => ServiceProps = ({ categories, services, setCategories }) => {
  const sortedServices = useMemo(
    () =>
      services.sort((a, b) => {
        if (a.isEssential && b.isEssential) {
          return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
        }

        if (a.isEssential && !b.isEssential) {
          return -1;
        }

        if (!a.isEssential && b.isEssential) {
          return 1;
        }

        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
      }),
    [services],
  );

  const onServiceToggle = useCallback(
    (checked: boolean, serviceId: string): void => {
      setCategories(
        categories.reduce((acc: UICategory[], cat) => {
          return [
            ...acc,
            {
              ...cat,
              services: cat.services.map((temp: UIService) => {
                if (temp.id === serviceId) {
                  const updatedService = temp;
                  updatedService.consent = {
                    ...updatedService.consent,
                    status: checked,
                  };

                  return updatedService;
                }

                return temp;
              }),
            },
          ];
        }, []),
      );
    },
    [categories, setCategories],
  );

  return {
    categories,
    onServiceToggle,
    services: sortedServices,
    setCategories,
  };
};

export default MapServices;
